import React from 'react';
import ShadowModal from '../ShadowModal'
import { observer } from "mobx-react-lite"
import AppState from '../../AppState';

interface Props {
    state: AppState
}

const EditFile = observer(({state}: Props) => {
    if (!state.fileToEdit) {
        return null
    }

    const handleChange = (e: { target: { name: any; value: any; }; }) => {
        state.setFileToEdit({...state.fileToEdit, [e.target.name]: e.target.value})
    }

    return (
        <ShadowModal contentLabel="Muokkaa" isOpen={!!state.fileToEdit} onRequestClose={() => state.setFileToEdit(null)} shouldCloseOnOverlayClick={true} >
            <div className="edit-modal file-modal">
                <p>{state.fileToEdit.path}</p>
                <div>
                    <input placeholder='Nimi' name="name" onChange={handleChange} value={state.fileToEdit.name ? state.fileToEdit.name : ''} />
                </div>
                <div>
                    <input placeholder='Tagit' name="tags" onChange={handleChange} value={state.fileToEdit.tags ? state.fileToEdit.tags : ''} />
                </div>
                <div className="floating-footer">
                    <button className="success" onClick={() => {state.handleFileUpdate(); state.setFileToEdit(null)}}>Save</button>
                    <button className="danger" onClick={() => {state.handleFileDelete(); state.setFileToEdit(null)}}>Delete</button>
                </div>
            </div>
        </ShadowModal>
    )
})

export default EditFile